import {
  Box,
  Grid,
  Typography,
  Divider,
  MenuItem,
  Stack,
  Chip,
  CircularProgress,
  ClickAwayListener,
  Paper,
  List,
  ListItemButton,
  ListItemText,
  Popper,
} from "@mui/material";
import Label from "../label";
import TextInput from "../textInput";
import CustomDropDown from "../select";
import { CONTRACT_TERMS, POSITION, COUNTIES } from "../../lib/Variable";
import { handleOpenSnackBar } from "../../utils/helper";
import { customerBankValidation } from "../../services/WebUser";
import { useContext, useEffect, useRef, useState } from "react";
import GlobalButton from "../button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import axios from "axios";
import { baseUrl } from "../../services";
import CustomCheckBox from "../checkbox";
import useDebounce from "../hooks/useDebounce";
import { useParams } from "react-router-dom";
import { AppContext } from "../../lib/Context";
import { getAccessToken } from "../../services/tokenStore";

const KeyInformation = ({
  inputValues,
  setInputValues,
  inputError,
  setInputError,
  id,
}) => {
  const searchRef = useRef(null);
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const debounceTerm = useDebounce(searchValue, 1000);
  const [addresses, setAddresses] = useState([]);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const { userData } = useContext(AppContext);

  const isViewMode = params?.type === "view" ? true : false;

  const handleChangeInputValue = (event) => {
    const { name, value } = event.target;

    if (name === "bankAccountNumber" || name === "bankSortCode") {
      setInputValues((prev) => ({ ...prev, isBankDetailsVerified: false }));
    }

    setInputError((prev) => ({ ...prev, [name]: "" }));
    setInputValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeInstallAddrSame = (prev) => {
    if (isViewMode) return;

    if (!prev.addressLine1 || !prev.town || !prev.postcode || !prev.country) {
      return handleOpenSnackBar(
        "error",
        "Address line 1, Town, Postcode and Country are required",
      );
    }

    setInputValues((prev) => ({
      ...prev,
      isInstallAddrSame: !prev.isInstallAddrSame,
    }));
    if (!prev?.isInstallAddrSame) {
      setInputValues((prev) => ({
        ...prev,
        installationAddress: `${prev.addressLine1}, ${prev.town}, ${prev.postcode}, ${prev.country}`,
      }));
    } else {
      setInputValues((prev) => ({ ...prev, installationAddress: "" }));
    }
  };

  const handleCheckvalidateBankDetail = async () => {
    if (isLoading) return;

    if (!inputValues.bankAccountNumber || !inputValues.bankSortCode) {
      return handleOpenSnackBar(
        "error",
        "Account number or sort code is missing",
      );
    }

    try {
      const payload = {
        accountNumber: inputValues.bankAccountNumber,
        sortCode: inputValues.bankSortCode,
      };
      setIsLoading(true);
      const response = await customerBankValidation(payload);
      if (response?.data?.status === "success") {
        const data = response.data.data;
        if (data?.IsCorrect === "True") {
          setInputValues((prev) => ({ ...prev, isBankDetailsVerified: true }));
          handleOpenSnackBar("success", response?.data?.message);
        } else {
          setInputValues((prev) => ({ ...prev, isBankDetailsVerified: false }));
          handleOpenSnackBar("error", "Debit details not verified");
        }
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadAgreement = async (envelopeId) => {
    if (!envelopeId)
      return handleOpenSnackBar("error", "Envelope ID is missing");

    const token = getAccessToken();

    try {
      setIsDownloadLoading(true);
      const response = await axios.get(
        `${baseUrl}agreement/download/${envelopeId}`,
        {
          headers: {
            ...(token && {
              Authorization: `Bearer ${token}`,
            }),
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `service_agreement_${envelopeId}.pdf`;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      handleOpenSnackBar("error", "Error downloading Pdf");
    } finally {
      setIsDownloadLoading(false);
    }
  };

  const handleGetAddressByPostCode = async () => {
    try {
      if (!debounceTerm) return;
      setIsLoading1(true);

      const baseUrl =
        "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws";
      const apiKey = "YZ17-GD31-UB82-BF71";

      const res = await axios.get(baseUrl, {
        params: {
          Key: apiKey,
          Text: debounceTerm,
          Origin: "GBR",
        },
      });

      const items = res?.data?.Items || [];
      let finalAddresses = [];

      for (const item of items) {
        if (item.Type === "Address") {
          finalAddresses.push(item);
        } else if (item.Type === "Container") {
          try {
            const childRes = await axios.get(baseUrl, {
              params: {
                Key: apiKey,
                Container: item.Id,
                Origin: "GBR",
              },
            });
            const childItems = childRes?.data?.Items || [];
            finalAddresses.push(...childItems);
          } catch (err) {
            console.error("Error fetching child addresses:", err);
          }
        }
      }

      setAnchorEl(searchRef.current);
      setAddresses(finalAddresses);
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading1(false);
    }
  };

  useEffect(() => {
    handleGetAddressByPostCode();
  }, [debounceTerm]);

  const handleFetchFormatedAddress = async (data) => {
    if (!data) return;

    const formatedAddress = `${data.Text}`;

    if (data.Type === "Container") {
      setInputValues((prev) => ({
        ...prev,
        addressLine1: formatedAddress,
        town: "",
        postcode: "",
        country: "",
      }));
    } else if (data.Id && data.Type === "Address") {
      try {
        setIsLoading2(true);
        const response = await axios.get(
          `https://services.postcodeanywhere.co.uk/capture/interactive/retrieve/v1.2/json3.ws`,
          {
            params: {
              Key: "YZ17-GD31-UB82-BF71",
              Id: data.Id,
            },
          },
        );

        if (response.data?.Items?.length > 0) {
          const addressData = response.data.Items.find((x) => x.Id === data.Id);

          if (addressData) {
            setInputValues((prev) => ({
              ...prev,
              // address1: addressData.Label?.replace(/\n/g, " "),
              addressLine1: formatedAddress,
              town: addressData.District || addressData.City,
              postcode: addressData.PostalCode,
              country: addressData.CountryName,
            }));
          } else {
            setInputValues((prev) => ({
              ...prev,
              addressLine1: formatedAddress,
              town: "",
              postcode: "",
              country: "",
            }));
          }
        }
      } catch (error) {
        setInputValues((prev) => ({
          ...prev,
          addressLine1: formatedAddress,
          town: "",
          postcode: "",
          country: "",
        }));
      } finally {
        setIsLoading2(false);
      }
    } else {
      setInputValues((prev) => ({
        ...prev,
        addressLine1: formatedAddress,
        town: "",
        postcode: "",
        country: "",
      }));
    }
  };

  return (
    <Box>
      <Stack
        mb={2}
        gap={1}
        direction={{ md: "row" }}
        alignContent={{ md: "center" }}
        justifyContent={"space-between"}
      >
        <Typography variant="h6">Key Information</Typography>
        {inputValues?.envelopId && (
          <GlobalButton
            variant={"custom_gradient"}
            disabled={isDownloadLoading}
            title={
              isDownloadLoading
                ? "Downloading..."
                : "Download Docusign Agreement"
            }
            handleClickBtn={() =>
              handleDownloadAgreement(inputValues?.envelopId)
            }
            style={{
              width: "auto",
              height: 35,
              borderRadius: "8px",
            }}
          />
        )}
      </Stack>

      {/* Business Information Section */}
      <Typography variant="subtitle1" mb={1} fontWeight="bold">
        Business Information
      </Typography>
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Label
            title={"Merchant/Business Name"}
            required
            htmlFor={"business-name"}
          />
          <TextInput
            id={"business-name"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.businessName)}
            helperText={inputError.businessName || ""}
            defaultStyle={true}
            placeholder={"Enter Business/Merchant name"}
            value={inputValues.businessName}
            name={"businessName"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label
            title={"Trading Name (If Different)"}
            htmlFor={"trading-name"}
          />
          <TextInput
            id={"trading-name"}
            type={"text"}
            size="small"
            error={Boolean(inputError.tradingName)}
            helperText={inputError.tradingName || ""}
            defaultStyle={true}
            placeholder={"Enter Trading name"}
            value={inputValues.tradingName}
            name={"tradingName"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Business Phone"} htmlFor={"business-phone"} required />
          <TextInput
            id={"business-phone"}
            type={"number"}
            size="small"
            error={Boolean(inputError.businessPhone)}
            helperText={inputError.businessPhone || ""}
            defaultStyle={true}
            placeholder={"Enter Business phone"}
            value={inputValues.businessPhone}
            name={"businessPhone"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Business URL"} htmlFor={"business-url"} />
          <TextInput
            id={"business-url"}
            type={"url"}
            size="small"
            error={Boolean(inputError.businessUrl)}
            helperText={inputError.businessUrl || ""}
            defaultStyle={true}
            placeholder={"Enter Business URL"}
            value={inputValues.businessUrl}
            name={"businessUrl"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Email"} required htmlFor={"email"} />
          <TextInput
            id={"email"}
            type={"email"}
            size="small"
            required
            error={Boolean(inputError.email)}
            helperText={inputError.email || ""}
            defaultStyle={true}
            placeholder={"Enter Email"}
            value={inputValues.email}
            name={"email"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label
            title={"Years in Business"}
            htmlFor={"years-in-business"}
            required
          />
          <CustomDropDown
            id={"years-in-business"}
            variant={"outlined"}
            value={inputValues.yearsInBusiness}
            name={"yearsInBusiness"}
            onChange={handleChangeInputValue}
            inputError={Boolean(inputError.yearsInBusiness)}
            helperText={inputError.yearsInBusiness || ""}
            stylePropos={{
              "& .MuiSelect-select": {
                padding: "12px 16px",
              },
            }}
            readonly={isViewMode}
          >
            {Array.from({ length: 100 }, (_, i) => i + 1).map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Registration No"} htmlFor={"registration-no"} />
          <TextInput
            id={"registration-no"}
            type={"number"}
            size="small"
            error={Boolean(inputError.registrationNo)}
            helperText={inputError.registrationNo || ""}
            defaultStyle={true}
            placeholder={"Enter Registration number"}
            value={inputValues.registrationNo}
            name={"registrationNo"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"VAT No (Optional)"} htmlFor={"vat-no"} />
          <TextInput
            id={"vat-no"}
            type={"number"}
            size="small"
            error={Boolean(inputError.vatNo)}
            helperText={inputError.vatNo || ""}
            defaultStyle={true}
            placeholder={"Enter VAT number"}
            value={inputValues.vatNo}
            name={"vatNo"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Address Information Section */}
      <Typography variant="subtitle1" mb={1} fontWeight="bold">
        Address Information
      </Typography>
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} position={"relative"}>
          <Label title={"Search Address"} htmlFor={"addresses"} />
          <TextInput
            id={"addresses"}
            defaultStyle={true}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            InputEndIcon={isLoading1 && <CircularProgress size={24} />}
            readonly={isViewMode}
          />
          <Box ref={searchRef}></Box>
          <Popper
            open={addresses?.length > 0}
            anchorEl={anchorEl}
            placement="bottom-start"
            style={{
              zIndex: 1500,
              width: searchRef.current?.clientWidth,
            }}
          >
            <ClickAwayListener onClickAway={() => setAddresses([])}>
              <Paper
                sx={{
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  backgroundColor: "background.paper",
                }}
              >
                <List>
                  {addresses.map((add) => (
                    <ListItemButton
                      key={add.Id}
                      onClick={() => {
                        handleFetchFormatedAddress(add);
                        setAddresses([]);
                        setSearchValue("");
                      }}
                    >
                      <ListItemText
                        primary={`${add.Text} ${add.Description}`}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </ClickAwayListener>
          </Popper>
        </Grid>
        <Grid item xs={12}>
          <Label title={"Address Line 1"} required htmlFor={"address-line-1"} />
          <TextInput
            id={"address-line-1"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.addressLine1)}
            helperText={inputError.addressLine1 || ""}
            defaultStyle={true}
            placeholder={"Enter Address line 1"}
            value={inputValues.addressLine1}
            name={"addressLine1"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            title={"Address Line 2 (Optional)"}
            htmlFor={"address-line-2"}
          />
          <TextInput
            id={"address-line-2"}
            type={"text"}
            size="small"
            error={Boolean(inputError.addressLine2)}
            helperText={inputError.addressLine2 || ""}
            defaultStyle={true}
            placeholder={"Enter Address line 2"}
            value={inputValues.addressLine2}
            name={"addressLine2"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Town/City"} required htmlFor={"town"} />
          <TextInput
            id={"town"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.town)}
            helperText={inputError.town || ""}
            defaultStyle={true}
            placeholder={"Enter Town/City"}
            value={inputValues.town}
            name={"town"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"County"} htmlFor={"county"} required />
          <CustomDropDown
            id={"county"}
            variant={"outlined"}
            required
            value={inputValues.county}
            name={"county"}
            onChange={handleChangeInputValue}
            inputError={Boolean(inputError.county)}
            helperText={inputError.county || ""}
            stylePropos={{
              "& .MuiSelect-select": {
                padding: "12px 16px",
              },
            }}
            readonly={isViewMode}
          >
            {COUNTIES.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val.value}>
                  {val.title}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Postcode"} required htmlFor={"postcode"} />
          <TextInput
            id={"postcode"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.postcode)}
            helperText={inputError.postcode || ""}
            defaultStyle={true}
            placeholder={"Enter Postcode"}
            value={inputValues.postcode}
            name={"postcode"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Country"} required htmlFor={"country"} />
          <TextInput
            id={"country"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.country)}
            helperText={inputError.country || ""}
            defaultStyle={true}
            placeholder={"Enter Country"}
            value={inputValues.country}
            name={"country"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Contact Information Section */}
      <Typography variant="subtitle1" mb={1} fontWeight="bold">
        Contact Information
      </Typography>
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Contact Name"} required htmlFor={"contact-name"} />
          <TextInput
            id={"contact-name"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.contactName)}
            helperText={inputError.contactName || ""}
            defaultStyle={true}
            placeholder={"Enter Contact name"}
            value={inputValues.contactName}
            name={"contactName"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Position"} htmlFor={"position"} required />

          <CustomDropDown
            id={"position"}
            required
            variant={"outlined"}
            value={inputValues.position}
            name={"position"}
            onChange={handleChangeInputValue}
            inputError={Boolean(inputError.position)}
            helperText={inputError.position || ""}
            stylePropos={{
              "& .MuiSelect-select": {
                padding: "12px 16px",
              },
            }}
            readonly={isViewMode}
          >
            {POSITION.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val.value}>
                  {val.title}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Contact Phone"} required htmlFor={"contact-phone"} />
          <TextInput
            id={"contact-phone"}
            type={"number"}
            size="small"
            required
            error={Boolean(inputError.contactPhone)}
            helperText={inputError.contactPhone || ""}
            defaultStyle={true}
            placeholder={"Enter Contact phone"}
            value={inputValues.contactPhone}
            name={"contactPhone"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Installation Information Section */}
      <Typography variant="subtitle1" mb={1} fontWeight="bold">
        Installation Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction={"row"} alignItems={"center"} gap={1} mb={1}>
            <Label
              title={"Installation Address"}
              required
              htmlFor={"installation-address"}
              style={{ mb: 0, lineHeight: "normal" }}
            />
            <CustomCheckBox
              isChecked={inputValues.isInstallAddrSame}
              handleChecked={() => handleChangeInstallAddrSame(inputValues)}
            />
            <Label
              title={"(Same as Address Line 1)"}
              htmlFor={"is-install-addr-same"}
              style={{ mb: 0, lineHeight: "normal" }}
            />
          </Stack>
          <TextInput
            id={"installation-address"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.installationAddress)}
            helperText={inputError.installationAddress || ""}
            defaultStyle={true}
            placeholder={"Enter Installation address"}
            value={inputValues.installationAddress}
            name={"installationAddress"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label title={"Term"} htmlFor={"min-term"} required />
          <CustomDropDown
            id={"min-term"}
            required
            variant={"outlined"}
            value={inputValues.minTerm}
            name={"minTerm"}
            onChange={handleChangeInputValue}
            inputError={Boolean(inputError.minTerm)}
            helperText={inputError.minTerm || ""}
            stylePropos={{
              "& .MuiSelect-select": {
                padding: "12px 16px",
                // backgroundColor: "text.appLightBlue",
              },
            }}
            readonly={isViewMode}
          >
            {CONTRACT_TERMS.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val.value}>
                  {val.title}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label
            title={"On-site Installation Payment"}
            htmlFor={"installation-payment-onsite"}
            required
          />
          <TextInput
            id={"installation-payment-onsite"}
            type={"number"}
            size="small"
            required
            error={Boolean(inputError.onSitePayment)}
            helperText={inputError.onSitePayment || ""}
            defaultStyle={true}
            placeholder={"0"}
            value={inputValues.onSitePayment}
            name={"onSitePayment"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label
            title={"Total Monthly Payment (Terminal)"}
            htmlFor={"installation-payment-monthly"}
            required
          />
          <TextInput
            id={"installation-payment-monthly"}
            type={"number"}
            size="small"
            required
            error={Boolean(inputError.monthlyPayment)}
            helperText={inputError.monthlyPayment || ""}
            defaultStyle={true}
            placeholder={"0"}
            value={inputValues.monthlyPayment}
            name={"monthlyPayment"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Installation Information Section */}
      <Typography variant="subtitle1" mb={1} fontWeight="bold">
        Equipment Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Label
            title={"Equipment Model"}
            required
            htmlFor={"equipment-model"}
          />
          <TextInput
            id={"equipment-model"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.equipmentModel)}
            helperText={inputError.equipmentModel || ""}
            defaultStyle={true}
            placeholder={"Enter Equipment model"}
            value={inputValues.equipmentModel}
            name={"equipmentModel"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        {inputValues.manufacturer && (
          <Grid item xs={12} sm={4}>
            <Label title={"Manufacturer"} htmlFor={"manufacturer"} required />
            <TextInput
              id={"manufacturer"}
              type={"text"}
              size="small"
              required
              error={Boolean(inputError.manufacturer)}
              helperText={inputError.manufacturer || ""}
              defaultStyle={true}
              placeholder={"Enter Manufacturer"}
              value={inputValues.manufacturer}
              name={"manufacturer"}
              onChange={handleChangeInputValue}
              readonly={isViewMode}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={inputValues.manufacturer ? 2 : 6}>
          <Label title={"Quantity"} htmlFor={"quantity"} required />
          <TextInput
            id={"quantity"}
            type={"number"}
            size="small"
            required
            error={Boolean(inputError.quantity)}
            helperText={inputError.quantity || ""}
            defaultStyle={true}
            placeholder={"Enter Quantity"}
            value={inputValues.quantity}
            name={"quantity"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Installation Information Section */}
      <Stack
        direction={"row"}
        // justifyContent={"space-between"}
        alignItems={"center"}
        spacing={2}
      >
        <Typography variant="subtitle1" mb={1} fontWeight="bold">
          Bank Information
        </Typography>
        {inputValues.isBankDetailsVerified && (
          <Chip
            size="small"
            icon={<CheckCircleOutlineIcon />}
            label={"verified"}
            color="success"
          />
        )}
      </Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Label title={"Bank"} htmlFor={"bank-name"} required />
          <TextInput
            id={"bank-name"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.bankName)}
            helperText={inputError.bankName || ""}
            defaultStyle={true}
            placeholder={"Enter Bank name"}
            value={inputValues.bankName}
            name={"bankName"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label
            title={"Name on Bank Account"}
            htmlFor={"name-on-account"}
            required
          />
          <TextInput
            id={"name-on-account"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.nameOnAccount)}
            helperText={inputError.nameOnAccount || ""}
            defaultStyle={true}
            placeholder={"Enter Name on account"}
            value={inputValues.nameOnAccount}
            name={"nameOnAccount"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label
            title={"Account Number"}
            required
            htmlFor={"bank-account-number"}
          />
          <TextInput
            id={"bank-account-number"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.bankAccountNumber)}
            helperText={inputError.bankAccountNumber || ""}
            defaultStyle={true}
            placeholder={"Enter Bank account number"}
            value={inputValues.bankAccountNumber}
            name={"bankAccountNumber"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label title={"Sort Code"} required htmlFor={"bank-sort-code"} />
          <TextInput
            id={"bank-sort-code"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.bankSortCode)}
            helperText={inputError.bankSortCode || ""}
            defaultStyle={true}
            placeholder={"Enter Bank sort code"}
            value={inputValues.bankSortCode}
            name={"bankSortCode"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label title={"Post Code"} htmlFor={"bank-post-code"} required />
          <TextInput
            id={"bank-post-code"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.bankPostCode)}
            helperText={inputError.bankPostCode || ""}
            defaultStyle={true}
            placeholder={"Enter Bank post code"}
            value={inputValues.bankPostCode}
            name={"bankPostCode"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label title={"Address"} htmlFor={"bank-address"} required />
          <TextInput
            id={"bank-address"}
            type={"text"}
            size="small"
            required
            error={Boolean(inputError.bankAddress)}
            helperText={inputError.bankAddress || ""}
            defaultStyle={true}
            placeholder={"Enter Bank address"}
            value={inputValues.bankAddress}
            name={"bankAddress"}
            onChange={handleChangeInputValue}
            readonly={isViewMode}
          />
        </Grid>
        {inputValues.isBankDetailsVerified === false && (
          <Grid item xs={12} sm={6} alignSelf={"flex-end"}>
            <GlobalButton
              variant={"custom_gradient"}
              title={isLoading ? "Verifying...." : "Verify Bank Details"}
              style={{
                height: 40,
                width: "auto",
                borderRadius: 1,
              }}
              handleClickBtn={handleCheckvalidateBankDetail}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default KeyInformation;
